
import axios from 'axios';
import { API_URL } from '../config';
import moment from 'moment';

export const exportEmployeeList = async (
    token: string,
    file_format: string,
    filters: string[],
    filterBy: string,
    startDate?: string,
    endDate?: string
) => {    
    const formattedFileFormat = file_format.toLowerCase();

    const params: any = {
        file_format: formattedFileFormat,
        'filters[]': filters,
        filter_by: filterBy,
        start_date: startDate,
        end_date: endDate,
    };

    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    
    try {        
        const response = await axios.get(`${API_URL}/presenze/company/export-employees/`, {
            responseType: 'blob',
            headers: {
                'Authorization': `${token}`,
            },
            params,
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `employees.${formattedFileFormat === 'excel' ? 'xlsx' : 'csv'}`);
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        console.error('Error exporting employee list:', error);
    }
};


export const exportEmployeeAttendance = async (token: string, startDate: string, endDate: string, format: string, businessName: string, selectedUnit: number | null) => {
    try {
        const params = {
            start_date: startDate,
            end_date: endDate,
            request_format: format,
            unit: selectedUnit,
        };

        const response = await axios.get(`${API_URL}/presenze/company/export-presenze/`, {
            responseType: 'blob',
            headers: {
                Authorization: `${token}`,
            },
            params: params,
        });

        if (response.status === 200) {
            const formattedStartDate = moment(startDate).format('DD-MM-YYYY');
            const formattedEndDate = moment(endDate).format('DD-MM-YYYY');

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            
            let extension = 'txt';
            if (format === 'excel') extension = 'xlsx';
            else if (format === 'trripw') extension = 'xml';

            link.setAttribute(
                'download',
                `Presenze_${businessName}_${formattedStartDate}_${formattedEndDate}.${extension}`
            );
            document.body.appendChild(link);
            link.click();
        } else {
            throw new Error(`Errore nell'esportazione: ${response.statusText}`);
        }
    } catch (error: any) {
        throw error.response?.data?.message || 'Errore sconosciuto durante l\'esportazione delle presenze';
    }
};


export const exportCostRefunds = async (token: string, month: number, year: number, businessName: string) => {
    try {
        const response = await axios.get(`${API_URL}/presenze/company/export-cost-refund/`, {
            responseType: 'blob', 
            headers: { 'Authorization': `${token}` },
            params: { month, year }
        });

        if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', `Rimborsi_spese_${month}_${year}_${businessName}.zip`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return { success: true };
        } else if (response.status === 404) {
            return { success: false, error: 'Nessun rimborso spesa trovato per il mese e l\'anno selezionati.' };
        } else {
            return { success: false, error: response.data.error || 'Errore non specificato.' };
        }
    } catch (error: any) {
        let errorMessage = 'Si è verificato un errore di rete.';
        if (error.response) {
            if (error.response.status === 404) {
                errorMessage = 'Nessun rimborso spesa trovato per il mese e l\'anno selezionati.';
            } else {
                errorMessage = error.response.data.error || 'Errore nella risposta del server.';
            }
        } else if (error.request) {
            errorMessage = 'Nessuna risposta ricevuta dal server.';
        }
        return { success: false, error: errorMessage };
    }
};


export const exportAttendanceReports = async (token: string, startDate: string, endDate: string, selectedUnit: number | null) => {
    try {
        const params = {
            start_date: startDate,
            end_date: endDate,
            ou: selectedUnit,
        };

        const response = await axios.get(`${API_URL}/presenze/company/reports/attendance/export/`, {
            responseType: 'blob',
            headers: {
                Authorization: `${token}`,
            },
            params: params,
        });

        if (response.status === 200) {
            const formattedStartDate = moment(startDate).format('DD-MM-YYYY');
            const formattedEndDate = moment(endDate).format('DD-MM-YYYY');

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `Report_${formattedStartDate}_${formattedEndDate}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
        } else {
            throw new Error(`Errore nell'esportazione: ${response.statusText}`);
        }
    } catch (error: any) {
        throw error.response?.data?.message || 'Errore sconosciuto durante l\'esportazione';
    }
};


